import React from 'react';
import PropTypes from 'prop-types';

const Popup = ({ children, isOpen, className }) =>
  isOpen ? (
    <div className={`ken-configurator__popup ${className}`}>
      <div className='ken-configurator__popup-content'>{children}</div>
    </div>
  ) : null;

Popup.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

Popup.defaultProps = {
  className: '',
};

export default Popup;
